
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as carto17Hk3H3NYEO_FFdaJOjgwf0g_fC_a17YdUdJaFSiRYMeta } from "/vercel/path0/pages/cart.vue?macro=true";
import { default as debugI_QvvWa932qo4ck4pkKimMLzswQoFM11sIHH7JqcxboMeta } from "/vercel/path0/pages/debug.vue?macro=true";
import { default as fontsQyRA_bOCnpoKImPzmacpl6kIL9zExQCC__7KUBNnkJkMeta } from "/vercel/path0/pages/fonts.vue?macro=true";
import { default as searchE0nZQqeAMWsUG5cnJAPfFVP401IiagPhLDCR_YaJLbcMeta } from "/vercel/path0/pages/search.vue?macro=true";
import { default as login9kNGJYnegq8rWk72uRK_bV6k6oZIODiWnCUd95wPiW4Meta } from "/vercel/path0/pages/account/login.vue?macro=true";
import { default as resetGkm6G6JGkq8AIWMDdgerJbOcZ7u9JFzDdga5IVyVNakMeta } from "/vercel/path0/pages/account/reset.vue?macro=true";
import { default as register7Tjc55n9YUIJjpL51GQHBjWB4hhxDCOBpqmuCiBd5mUMeta } from "/vercel/path0/pages/account/register.vue?macro=true";
import { default as _91id_93eTmlZQh2q_U5QbrbhIh5K07fli5MdqDHaDqYhxgd9hYMeta } from "/vercel/path0/pages/account/orders/[id].vue?macro=true";
import { default as verifyEmaill6CvWZlT00d4DqM5YgHI_mxz8i7xFotrLjwIOwcDXk4Meta } from "/vercel/path0/pages/account/verifyEmail.vue?macro=true";
import { default as indexEN7UYhqJJNXclle_q__VPMBQKZZ_XwL0cMSTDmGvLi4Meta } from "/vercel/path0/pages/account/orders/index.vue?macro=true";
import { default as indexb3R29QQT1_8_Bqpfey8beFTCm1HHVyx_597BKNwYdgAMeta } from "/vercel/path0/pages/account/courses/index.vue?macro=true";
import { default as passwordReset9yTTYS8QeaDjEKZOTN_MDVNM996BdV9qKdCalMXJxk4Meta } from "/vercel/path0/pages/account/passwordReset.vue?macro=true";
import { default as index9M_4SjD6JJRIjIomh2dVPamwoa4nPruTKRRwCm7RL0EMeta } from "/vercel/path0/pages/account/exercises/index.vue?macro=true";
import { default as detailsEeXzz4LwS2gn5AEp0mDeM25DF7OJDakJ96TV9ZDLt8AMeta } from "/vercel/path0/pages/account/profile/details.vue?macro=true";
import { default as addressesoiHRpzqv0EJHsOK9OVNcP6qrNP1BnuYE_GNqbPBrwgMMeta } from "/vercel/path0/pages/account/profile/addresses.vue?macro=true";
import { default as workoutsGjhMMTqMWDqKwYljSFD7LwB1meOyt3D0m2zk4uFUX_UMeta } from "/vercel/path0/pages/account/exercises/workouts.vue?macro=true";
import { default as indexKS5_OOeJTVrQsDSjAypHZaxUYs_Yi0jLC6GXDpv0zSsMeta } from "/vercel/path0/pages/account/exercises/premium/index.vue?macro=true";
import { default as _91slug_93AtkwgDCH4Jmo6OF_W5gYKdVbNQ5qe3YagvKVXFZQM_4Meta } from "/vercel/path0/pages/account/exercises/premium/[slug].vue?macro=true";
import { default as account7_R9ulYiZeZ_GrHnPC281Y5Zif3_d2qTALfK0BMjqEUMeta } from "/vercel/path0/pages/account.vue?macro=true";
import { default as _91_46_46_46slug_93eD0_aLJH_SWaJVw5CBvPn8cEE2xWIMXlvr23TEyf8PMMeta } from "/vercel/path0/pages/[...slug].vue?macro=true";
import { default as processing8__AQ6w7Ayu7WO0Prm91p8NPwKXikt4klxL4K8zCquEMeta } from "/vercel/path0/pages/processing.vue?macro=true";
import { default as indexy4anpwv8RgJL1xsHEkIFeeBFrRfb2qJ9ikh9XD7CLAIMeta } from "/vercel/path0/pages/shop/index.vue?macro=true";
import { default as index8TnTrG1RLdezOSU25M4mZcfRoygosPx29K_pj23ghrsMeta } from "/vercel/path0/pages/about/index.vue?macro=true";
import { default as _91slug_93zU8XLkEs0SNcqU8WVGHeEFcy_pU_4Tdxi_ZvMJbUBYwMeta } from "/vercel/path0/pages/about/[slug].vue?macro=true";
import { default as _91slug_930uOZl0yqO05zRWaVCER1BTl48phPQtM4iBMk0CV_7mgMeta } from "/vercel/path0/pages/story/[slug].vue?macro=true";
import { default as index8pOPo_MmsNeaNPH0Cac_ENGuB554OoXgM_UsG006imIMeta } from "/vercel/path0/pages/academy/index.vue?macro=true";
import { default as indexNdvo7eny1MAE_c_BDueLRtPyossWin_mbkbQVEtUn8kMeta } from "/vercel/path0/pages/experts/index.vue?macro=true";
import { default as indexJY4MRQvdhxPNoUF4AFllbL59PPwL7XMtczUcnCnal0IMeta } from "/vercel/path0/pages/returns/index.vue?macro=true";
import { default as labelHp6Q5Fllja8L_cvDEWWYcTTT41p4c3FarEIEyjQ_zWIMeta } from "/vercel/path0/pages/returns/label.vue?macro=true";
import { default as orderoSVPko7dj62xoQGx7sxX9_hcmEIykFeLMAsvM9i7kloMeta } from "/vercel/path0/pages/returns/order.vue?macro=true";
import { default as indexJ2L_Wnt3WpUkRvfOqtUguiqik3mLFBnVDTA_TgWq4gQMeta } from "/vercel/path0/pages/stories/index.vue?macro=true";
import { default as _91slug_93pbL6ZPBg6ZvRiSesPc0Ko_mZVigAEBTPFioR0RN3G0sMeta } from "/vercel/path0/pages/routine/[slug].vue?macro=true";
import { default as _91slug_93ukb6ytBTIEUo5a7BP7KUuAjNmhZUtdyi2FtURUJxoX8Meta } from "/vercel/path0/pages/stories/[slug].vue?macro=true";
import { default as index16Ptkqjza7kOqLviXx5YfGY9MQEr9ZkCg9BQ_VRXfmMMeta } from "/vercel/path0/pages/knowledge/index/index.vue?macro=true";
import { default as indexDuR1WHKmHggMj3TfC7pZhNu9Ma6cSH2G51wtQQjswT0Meta } from "/vercel/path0/pages/knowledge/index/[topic]/index.vue?macro=true";
import { default as _91slug_93AGgqVGveBpUbhXV8rx4_j4JDF_hmTxyS4gwcxZbi2EMMeta } from "/vercel/path0/pages/knowledge/index/category/[slug].vue?macro=true";
import { default as articlesJ8TClYlYoivqOdk1mAcbMqI6pEm61rrdgxU8ObBrl7wMeta } from "/vercel/path0/pages/knowledge/index/[topic]/articles.vue?macro=true";
import { default as _91category_936nefCRDhebJyGrbtNKG_Bt9hy03IHimMFyYeGZ1OH2IMeta } from "/vercel/path0/pages/knowledge/index/[topic]/[category].vue?macro=true";
import { default as indexer6HU_HqrwSxRZpFVbIPTgveLDAY_GxXiOdCB3_z2N4Meta } from "/vercel/path0/pages/knowledge/index.vue?macro=true";
import { default as _91slug_93_Yzn_mcvpcrxbHQMkMS8QzhOlnl5r_Krv7P91fg9lGEMeta } from "/vercel/path0/pages/products/[slug].vue?macro=true";
import { default as _91_46_46_46slug_93WNr4_Gd2TUxJfKSXYaKuSi__5S8E__iBrsIkkcKQ7U8Meta } from "/vercel/path0/pages/academy/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93_1s3vILwTOKB_rGOu_xQOL463cvZAj9spkLucYUBKx4Meta } from "/vercel/path0/pages/service/[...slug].vue?macro=true";
import { default as indexQ0SJA_7g2FqjeSUM0DJnjfsQPVrhP0Jvl2t4LliB5CEMeta } from "/vercel/path0/pages/shop/[slug]/index.vue?macro=true";
import { default as _91_46_46_46slug_93Al_NnYGJAh3gEgFl_Sba2Mw7_0EFUK9ZjNNPa_vTndoMeta } from "/vercel/path0/pages/exercises/[...slug].vue?macro=true";
import { default as indexk7oct_Lb2qbJ7zK5YD91I2iKTWrk2KY1nFmakH6TaBMMeta } from "/vercel/path0/pages/article/[slug]/index.vue?macro=true";
import { default as indexOW4m65SdK4Rv4h82IBEG30CNqV7__RSbVZDeRQ2MLvgMeta } from "/vercel/path0/pages/experts/[slug]/index.vue?macro=true";
import { default as indexPyMhLdUfWLX5lvqv3m_NDoawgdNWkMc4t_1po3UO9roMeta } from "/vercel/path0/pages/collections/[handle]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "cart___ch-de",
    path: "/ch-de/cart",
    component: () => import("/vercel/path0/pages/cart.vue")
  },
  {
    name: "cart___ch-fr",
    path: "/ch-fr/cart",
    component: () => import("/vercel/path0/pages/cart.vue")
  },
  {
    name: "debug___ch-de",
    path: "/ch-de/debug",
    component: () => import("/vercel/path0/pages/debug.vue")
  },
  {
    name: "debug___ch-fr",
    path: "/ch-fr/debug",
    component: () => import("/vercel/path0/pages/debug.vue")
  },
  {
    name: "fonts___ch-de",
    path: "/ch-de/fonts",
    component: () => import("/vercel/path0/pages/fonts.vue")
  },
  {
    name: "fonts___ch-fr",
    path: "/ch-fr/fonts",
    component: () => import("/vercel/path0/pages/fonts.vue")
  },
  {
    name: "index___ch-de",
    path: "/ch-de",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___ch-fr",
    path: "/ch-fr",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "search___ch-de",
    path: "/ch-de/search",
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "search___ch-fr",
    path: "/ch-fr/search",
    component: () => import("/vercel/path0/pages/search.vue")
  },
  {
    name: "account___ch-de",
    path: "/ch-de/account",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/pages/account.vue"),
    children: [
  {
    name: "account-login___ch-de",
    path: "login",
    component: () => import("/vercel/path0/pages/account/login.vue")
  },
  {
    name: "account-reset___ch-de",
    path: "reset",
    component: () => import("/vercel/path0/pages/account/reset.vue")
  },
  {
    name: "account-register___ch-de",
    path: "register",
    component: () => import("/vercel/path0/pages/account/register.vue")
  },
  {
    name: "account-orders-id___ch-de",
    path: "orders/:id()",
    component: () => import("/vercel/path0/pages/account/orders/[id].vue")
  },
  {
    name: "account-verifyEmail___ch-de",
    path: "verifyEmail",
    component: () => import("/vercel/path0/pages/account/verifyEmail.vue")
  },
  {
    name: "account-orders___ch-de",
    path: "orders",
    meta: indexEN7UYhqJJNXclle_q__VPMBQKZZ_XwL0cMSTDmGvLi4Meta || {},
    component: () => import("/vercel/path0/pages/account/orders/index.vue")
  },
  {
    name: "account-courses___ch-de",
    path: "courses",
    meta: indexb3R29QQT1_8_Bqpfey8beFTCm1HHVyx_597BKNwYdgAMeta || {},
    component: () => import("/vercel/path0/pages/account/courses/index.vue")
  },
  {
    name: "account-passwordReset___ch-de",
    path: "passwordReset",
    component: () => import("/vercel/path0/pages/account/passwordReset.vue")
  },
  {
    name: "account-exercises___ch-de",
    path: "exercises",
    component: () => import("/vercel/path0/pages/account/exercises/index.vue")
  },
  {
    name: "account-profile-details___ch-de",
    path: "profile/details",
    component: () => import("/vercel/path0/pages/account/profile/details.vue")
  },
  {
    name: "account-profile-addresses___ch-de",
    path: "profile/addresses",
    meta: addressesoiHRpzqv0EJHsOK9OVNcP6qrNP1BnuYE_GNqbPBrwgMMeta || {},
    component: () => import("/vercel/path0/pages/account/profile/addresses.vue")
  },
  {
    name: "account-exercises-workouts___ch-de",
    path: "exercises/workouts",
    component: () => import("/vercel/path0/pages/account/exercises/workouts.vue")
  },
  {
    name: "account-exercises-premium___ch-de",
    path: "exercises/premium",
    component: () => import("/vercel/path0/pages/account/exercises/premium/index.vue")
  },
  {
    name: "account-exercises-premium-slug___ch-de",
    path: "exercises/premium/:slug()",
    component: () => import("/vercel/path0/pages/account/exercises/premium/[slug].vue")
  }
]
  },
  {
    name: "account___ch-fr",
    path: "/ch-fr/account",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/pages/account.vue"),
    children: [
  {
    name: "account-login___ch-fr",
    path: "login",
    component: () => import("/vercel/path0/pages/account/login.vue")
  },
  {
    name: "account-reset___ch-fr",
    path: "reset",
    component: () => import("/vercel/path0/pages/account/reset.vue")
  },
  {
    name: "account-register___ch-fr",
    path: "register",
    component: () => import("/vercel/path0/pages/account/register.vue")
  },
  {
    name: "account-orders-id___ch-fr",
    path: "orders/:id()",
    component: () => import("/vercel/path0/pages/account/orders/[id].vue")
  },
  {
    name: "account-verifyEmail___ch-fr",
    path: "verifyEmail",
    component: () => import("/vercel/path0/pages/account/verifyEmail.vue")
  },
  {
    name: "account-orders___ch-fr",
    path: "orders",
    meta: indexEN7UYhqJJNXclle_q__VPMBQKZZ_XwL0cMSTDmGvLi4Meta || {},
    component: () => import("/vercel/path0/pages/account/orders/index.vue")
  },
  {
    name: "account-courses___ch-fr",
    path: "courses",
    meta: indexb3R29QQT1_8_Bqpfey8beFTCm1HHVyx_597BKNwYdgAMeta || {},
    component: () => import("/vercel/path0/pages/account/courses/index.vue")
  },
  {
    name: "account-passwordReset___ch-fr",
    path: "passwordReset",
    component: () => import("/vercel/path0/pages/account/passwordReset.vue")
  },
  {
    name: "account-exercises___ch-fr",
    path: "exercises",
    component: () => import("/vercel/path0/pages/account/exercises/index.vue")
  },
  {
    name: "account-profile-details___ch-fr",
    path: "profile/details",
    component: () => import("/vercel/path0/pages/account/profile/details.vue")
  },
  {
    name: "account-profile-addresses___ch-fr",
    path: "profile/addresses",
    meta: addressesoiHRpzqv0EJHsOK9OVNcP6qrNP1BnuYE_GNqbPBrwgMMeta || {},
    component: () => import("/vercel/path0/pages/account/profile/addresses.vue")
  },
  {
    name: "account-exercises-workouts___ch-fr",
    path: "exercises/workouts",
    component: () => import("/vercel/path0/pages/account/exercises/workouts.vue")
  },
  {
    name: "account-exercises-premium___ch-fr",
    path: "exercises/premium",
    component: () => import("/vercel/path0/pages/account/exercises/premium/index.vue")
  },
  {
    name: "account-exercises-premium-slug___ch-fr",
    path: "exercises/premium/:slug()",
    component: () => import("/vercel/path0/pages/account/exercises/premium/[slug].vue")
  }
]
  },
  {
    name: "slug___ch-de",
    path: "/ch-de/:slug(.*)*",
    component: () => import("/vercel/path0/pages/[...slug].vue")
  },
  {
    name: "slug___ch-fr",
    path: "/ch-fr/:slug(.*)*",
    component: () => import("/vercel/path0/pages/[...slug].vue")
  },
  {
    name: "processing___ch-de",
    path: "/ch-de/processing",
    component: () => import("/vercel/path0/pages/processing.vue")
  },
  {
    name: "processing___ch-fr",
    path: "/ch-fr/processing",
    component: () => import("/vercel/path0/pages/processing.vue")
  },
  {
    name: "shop___ch-de",
    path: "/ch-de/shop",
    component: () => import("/vercel/path0/pages/shop/index.vue")
  },
  {
    name: "shop___ch-fr",
    path: "/ch-fr/shop",
    component: () => import("/vercel/path0/pages/shop/index.vue")
  },
  {
    name: "about___ch-de",
    path: "/ch-de/ueber-blackroll",
    component: () => import("/vercel/path0/pages/about/index.vue")
  },
  {
    name: "about___ch-fr",
    path: "/ch-fr/a-propos-de-blackroll",
    component: () => import("/vercel/path0/pages/about/index.vue")
  },
  {
    name: "about-slug___ch-de",
    path: "/ch-de/ueber-blackroll/:slug()",
    component: () => import("/vercel/path0/pages/about/[slug].vue")
  },
  {
    name: "about-slug___ch-fr",
    path: "/ch-fr/a-propos-de-blackroll/:slug()",
    component: () => import("/vercel/path0/pages/about/[slug].vue")
  },
  {
    name: "story-slug___ch-de",
    path: "/ch-de/story/:slug()",
    component: () => import("/vercel/path0/pages/story/[slug].vue")
  },
  {
    name: "story-slug___ch-fr",
    path: "/ch-fr/story/:slug()",
    component: () => import("/vercel/path0/pages/story/[slug].vue")
  },
  {
    name: "academy___ch-de",
    path: "/ch-de/academy",
    component: () => import("/vercel/path0/pages/academy/index.vue")
  },
  {
    name: "academy___ch-fr",
    path: "/ch-fr/academy",
    component: () => import("/vercel/path0/pages/academy/index.vue")
  },
  {
    name: "experts___ch-de",
    path: "/ch-de/experten",
    component: () => import("/vercel/path0/pages/experts/index.vue")
  },
  {
    name: "experts___ch-fr",
    path: "/ch-fr/experten",
    component: () => import("/vercel/path0/pages/experts/index.vue")
  },
  {
    name: "returns___ch-de",
    path: "/ch-de/ruecksendungen",
    component: () => import("/vercel/path0/pages/returns/index.vue")
  },
  {
    name: "returns___ch-fr",
    path: "/ch-fr/retours",
    component: () => import("/vercel/path0/pages/returns/index.vue")
  },
  {
    name: "returns-label___ch-de",
    path: "/ch-de/ruecksendungen/label",
    component: () => import("/vercel/path0/pages/returns/label.vue")
  },
  {
    name: "returns-label___ch-fr",
    path: "/ch-fr/retours/label",
    component: () => import("/vercel/path0/pages/returns/label.vue")
  },
  {
    name: "returns-order___ch-de",
    path: "/ch-de/ruecksendungen/order",
    component: () => import("/vercel/path0/pages/returns/order.vue")
  },
  {
    name: "returns-order___ch-fr",
    path: "/ch-fr/retours/order",
    component: () => import("/vercel/path0/pages/returns/order.vue")
  },
  {
    name: "stories___ch-de",
    path: "/ch-de/stories",
    component: () => import("/vercel/path0/pages/stories/index.vue")
  },
  {
    name: "stories___ch-fr",
    path: "/ch-fr/stories",
    component: () => import("/vercel/path0/pages/stories/index.vue")
  },
  {
    name: "routine-slug___ch-de",
    path: "/ch-de/routine/:slug()",
    component: () => import("/vercel/path0/pages/routine/[slug].vue")
  },
  {
    name: "routine-slug___ch-fr",
    path: "/ch-fr/routine/:slug()",
    component: () => import("/vercel/path0/pages/routine/[slug].vue")
  },
  {
    name: "stories-slug___ch-de",
    path: "/ch-de/stories/:slug()",
    component: () => import("/vercel/path0/pages/stories/[slug].vue")
  },
  {
    name: "stories-slug___ch-fr",
    path: "/ch-fr/stories/:slug()",
    component: () => import("/vercel/path0/pages/stories/[slug].vue")
  },
  {
    name: indexer6HU_HqrwSxRZpFVbIPTgveLDAY_GxXiOdCB3_z2N4Meta?.name,
    path: "/ch-de/wissen",
    component: () => import("/vercel/path0/pages/knowledge/index.vue"),
    children: [
  {
    name: "knowledge-index___ch-de",
    path: "",
    component: () => import("/vercel/path0/pages/knowledge/index/index.vue")
  },
  {
    name: "knowledge-index-topic___ch-de",
    path: ":topic()",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/index.vue")
  },
  {
    name: "knowledge-index-category-slug___ch-de",
    path: "category/:slug()",
    component: () => import("/vercel/path0/pages/knowledge/index/category/[slug].vue")
  },
  {
    name: "knowledge-index-topic-articles___ch-de",
    path: ":topic()/articles",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/articles.vue")
  },
  {
    name: "knowledge-index-topic-category___ch-de",
    path: ":topic()/:category()",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/[category].vue")
  }
]
  },
  {
    name: indexer6HU_HqrwSxRZpFVbIPTgveLDAY_GxXiOdCB3_z2N4Meta?.name,
    path: "/ch-fr/connaissances",
    component: () => import("/vercel/path0/pages/knowledge/index.vue"),
    children: [
  {
    name: "knowledge-index___ch-fr",
    path: "",
    component: () => import("/vercel/path0/pages/knowledge/index/index.vue")
  },
  {
    name: "knowledge-index-topic___ch-fr",
    path: ":topic()",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/index.vue")
  },
  {
    name: "knowledge-index-category-slug___ch-fr",
    path: "category/:slug()",
    component: () => import("/vercel/path0/pages/knowledge/index/category/[slug].vue")
  },
  {
    name: "knowledge-index-topic-articles___ch-fr",
    path: ":topic()/articles",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/articles.vue")
  },
  {
    name: "knowledge-index-topic-category___ch-fr",
    path: ":topic()/:category()",
    component: () => import("/vercel/path0/pages/knowledge/index/[topic]/[category].vue")
  }
]
  },
  {
    name: "products-slug___ch-de",
    path: "/ch-de/products/:slug()",
    component: () => import("/vercel/path0/pages/products/[slug].vue")
  },
  {
    name: "products-slug___ch-fr",
    path: "/ch-fr/products/:slug()",
    component: () => import("/vercel/path0/pages/products/[slug].vue")
  },
  {
    name: "academy-slug___ch-de",
    path: "/ch-de/academy/:slug(.*)*",
    component: () => import("/vercel/path0/pages/academy/[...slug].vue")
  },
  {
    name: "academy-slug___ch-fr",
    path: "/ch-fr/academy/:slug(.*)*",
    component: () => import("/vercel/path0/pages/academy/[...slug].vue")
  },
  {
    name: "service-slug___ch-de",
    path: "/ch-de/service/:slug(.*)*",
    component: () => import("/vercel/path0/pages/service/[...slug].vue")
  },
  {
    name: "service-slug___ch-fr",
    path: "/ch-fr/service/:slug(.*)*",
    component: () => import("/vercel/path0/pages/service/[...slug].vue")
  },
  {
    name: "shop-slug___ch-de",
    path: "/ch-de/shop/:slug()",
    component: () => import("/vercel/path0/pages/shop/[slug]/index.vue")
  },
  {
    name: "shop-slug___ch-fr",
    path: "/ch-fr/shop/:slug()",
    component: () => import("/vercel/path0/pages/shop/[slug]/index.vue")
  },
  {
    name: "exercises-slug___ch-de",
    path: "/ch-de/uebungen/:slug(.*)*",
    component: () => import("/vercel/path0/pages/exercises/[...slug].vue")
  },
  {
    name: "exercises-slug___ch-fr",
    path: "/ch-fr/exercices/:slug(.*)*",
    component: () => import("/vercel/path0/pages/exercises/[...slug].vue")
  },
  {
    name: "article-slug___ch-de",
    path: "/ch-de/artikel/:slug()",
    component: () => import("/vercel/path0/pages/article/[slug]/index.vue")
  },
  {
    name: "article-slug___ch-fr",
    path: "/ch-fr/artikel/:slug()",
    component: () => import("/vercel/path0/pages/article/[slug]/index.vue")
  },
  {
    name: "experts-slug___ch-de",
    path: "/ch-de/experten/:slug()",
    component: () => import("/vercel/path0/pages/experts/[slug]/index.vue")
  },
  {
    name: "experts-slug___ch-fr",
    path: "/ch-fr/experten/:slug()",
    component: () => import("/vercel/path0/pages/experts/[slug]/index.vue")
  },
  {
    name: "collections-handle___ch-de",
    path: "/ch-de/collections/:handle()",
    component: () => import("/vercel/path0/pages/collections/[handle]/index.vue")
  },
  {
    name: "collections-handle___ch-fr",
    path: "/ch-fr/collections/:handle()",
    component: () => import("/vercel/path0/pages/collections/[handle]/index.vue")
  }
]